import React from "react";
import "./AboutPage.css";

const AboutPage = () => {
  return (
    <div className="about-root">
      <h1 className="about-title">About Page</h1>
      <p className="about-description">About Page Placeholder</p>
    </div>
  );
};

export default AboutPage;
